/// <reference types="vite/client" />
import './utils/storageInit';
import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Register PWA Service Worker for offline asset caching (only in production)
if (import.meta.env.PROD) {
  registerSW({ immediate: true });
} else {
  // Unregister existing service workers in development to prevent caching conflicts and HMR sluggishness
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister().then(success => {
          if (success) {
            console.log('[GWantt Dev] Unregistered stale service worker to prevent HMR caching lag');
          }
        });
      }
    });
  }
}

// Catch dynamic import (chunk load) errors and force reload the page to fetch the latest assets
window.addEventListener('error', (e) => {
  const message = String(e.message || '');
  const isChunkError = 
    message.toLowerCase().includes('failed to fetch dynamically imported module') ||
    message.toLowerCase().includes('error loading dynamically imported module') ||
    message.toLowerCase().includes('dynamically imported module') ||
    message.toLowerCase().includes('mime');
  
  if (isChunkError) {
    console.warn('Chunk loading error detected! Force-reloading page to get latest assets...', e);
    // Prevent looping if reload somehow keeps failing
    const reloadCount = parseInt(sessionStorage.getItem('chunk_reload_count') || '0', 10);
    if (reloadCount < 3) {
      sessionStorage.setItem('chunk_reload_count', String(reloadCount + 1));
      window.location.reload();
    }
  }
}, true);

window.addEventListener('unhandledrejection', (e) => {
  const reason = String(e.reason || '');
  const isChunkError = 
    reason.toLowerCase().includes('failed to fetch dynamically imported module') ||
    reason.toLowerCase().includes('error loading dynamically imported module') ||
    reason.toLowerCase().includes('dynamically imported module') ||
    reason.toLowerCase().includes('mime');
    
  if (isChunkError) {
    console.warn('Chunk loading rejection detected! Force-reloading page to get latest assets...', e);
    const reloadCount = parseInt(sessionStorage.getItem('chunk_reload_count') || '0', 10);
    if (reloadCount < 3) {
      sessionStorage.setItem('chunk_reload_count', String(reloadCount + 1));
      window.location.reload();
    }
  }
});

// Clear reload count after a successful load
setTimeout(() => {
  sessionStorage.removeItem('chunk_reload_count');
}, 5000);

import { ErrorBoundary } from './components/ErrorBoundary';

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <ErrorBoundary fallbackTitle="STRATUM konnte nicht initialisiert werden">
        <App />
      </ErrorBoundary>
    </StrictMode>,
  );
}
